import { Link } from 'react-router-dom';

export default function HeroBanner() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] flex items-center justify-center overflow-hidden" aria-labelledby="hero-title">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20warm%20gradient%20background%20with%20soft%20flowing%20shapes%20in%20coral%20and%20cream%20tones%2C%20minimalist%20artistic%20design%20with%20subtle%20texture%2C%20elegant%20and%20modern%20composition%2C%20Chinese%20aesthetic%20inspired%20warm%20atmosphere&width=1600&height=900&seq=hero-banner-main&orientation=landscape"
          alt="国产专区 - 优质国货精选平台"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/15 to-black/30"></div>
      </div>
      <div className="relative z-10 w-full text-center px-4">
        <h1 id="hero-title" className="text-3xl md:text-5xl font-heading font-bold text-white mb-4">
          优质国货，品质生活
        </h1>
        <p className="text-base md:text-lg text-white/90 max-w-2xl mx-auto mb-8">
          汇聚国内顶尖品牌，精选高性价比国产好物
        </p>
        <Link
          to="/category"
          className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-white px-8 py-3 rounded-full font-medium text-sm transition-all cursor-pointer whitespace-nowrap"
        >
          探索国货精选
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
    </section>
  );
}